import React from "react";
import { brand } from "../../../../config/appData";

export function CompletionHeader({ onLogoClick, onLogout, showFinish, showSteps }) {
  return (
    <>
      <header className="business-completion-top-header">
        <div className="business-completion-header-inner">
          <button
            type="button"
            className="business-completion-brand"
            onClick={onLogoClick}
            aria-label="Go to profile completion"
          >
            <span className="business-completion-logo">{brand.logoIcon}</span>
            <span className="business-completion-name">{brand.name}</span>
          </button>
        </div>
      </header>
      <div className="business-completion-container business-completion-header-section">
        <div className="business-completion-notice">
          <span className="business-completion-notice-icon" aria-hidden="true">
         {showFinish ? "✅" : "ℹ️"}
          </span>
          <p className="business-completion-notice-text">
            {showFinish
              ? "Your profile has been completed and is pending approval. You will be able to access the WeddingzVenue application once it is approved."

              : "Complete your profile to start listing your business."}
          </p>
        </div>
        <div className="business-completion-header">
          <div className="business-completion-header-row">
            <div>
              <h1 className="business-completion-title">
                {showSteps ? "Profile completed" : "Complete your business profile"}
              </h1>
              <p className="business-completion-subtitle">
                {showSteps ? "Thank you for completing your profile." : "Finish setting up your listing in a few steps"}m
              </p>
            </div>
            <button
              type="button"
              className="business-completion-logout-btn"
              onClick={onLogout}
              aria-label="Logout"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
